import { Card, Col, Row } from 'antd';
import styled from 'styled-components';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const Container = styled(Row)`
  margin: 12px;
`;

export const MapAndResourcesCol = styled(Col)`
  height: calc(100vh - 170px);
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;

export const DetailsCard = styled(Card)`
  margin-top: 12px;
  max-height: calc(100vh - 256px - 92px);
  overflow: auto;
  .ant-card-body {
    padding: 24px 0;
  }

  ${cssMediaBreakpoints.mobileOrTablet} {
    max-height: unset;
    overflow: visible;
  }
`;
